import { responseSchema } from '@/core/types/Response.ts'
import { mundoDeviceSchema } from '@/modules/sales/clients/types/MundoDevice.ts'
import { z } from 'zod'

export const MundoDeviceResponseSchema = responseSchema(mundoDeviceSchema)

export type MundoDeviceResponse = z.infer<typeof MundoDeviceResponseSchema>
